import React from 'react'
import styled from 'react-emotion'
import { themeGet as th } from 'styled-system'

import { SUI, Dropdown } from 'shared/ui'
import { propFunc } from 'util/functions'

import Icon from './Icon'

const buildOptions = (
  doOpenForwardPageExpanded,
  doOpenReplyDirectPage,
  doOpenTicketPage,
  { expand, isReplyingAll, isReplyingDirect }
) => {
  return [
    {
      key: 'reply-all',
      text: 'Reply all',
      onClick: propFunc(doOpenTicketPage, expand),
      value: 'reply-all',
      active: isReplyingAll,
    },
    {
      key: 'reply-direct',
      text: 'Direct reply',
      onClick: propFunc(doOpenReplyDirectPage, expand),
      value: 'reply-direct',
      active: isReplyingDirect,
    },
  ]
}

const SwitcherButton = ({
  className,
  doOpenForwardPageExpanded,
  doOpenReplyDirectPage,
  doOpenTicketPage,
  isExpanded,
  isReplyingAll,
  isReplyingDirect,
}) => {
  return (
    <SUI>
      <Dropdown
        className={className}
        options={propFunc(
          buildOptions,
          doOpenForwardPageExpanded,
          doOpenReplyDirectPage,
          doOpenTicketPage,
          {
            isReplyingAll,
            isReplyingDirect,
            expand: isExpanded,
          }
        )()}
        trigger={
          <Icon
            isReplyingAll={isReplyingAll}
            isReplyingDirect={isReplyingDirect}
          />
        }
      />
    </SUI>
  )
}

export default styled(SwitcherButton)`
  &&& {
    align-items: center;
    color: ${th('colors.gray')};
    cursor: pointer;
    display: inline-flex;

    &:hover {
      color: ${th('colors.blue')};
    }

    .Icon {
      line-height: 1.38;
    }

    .dropdown {
      &.icon {
        /* SUI override for a bigger caret thats closer to icon */
        font-size: ${th('fontSizes.1')}px !important;
        margin-left: ${th('space.1')}px !important;
      }
    }
  }
`
